module.exports = __webpack_public_path__ + "static/media/logoCollapsed.fec737a8.svg";